import Form from 'mlmi-library/components/form/v1/form'
import Mobile from 'mlmi-library/modules/mobile/v1/mobile'
import 'mlmi-library/plugins/submenu-parent'
import Header from './modules/header'
import Accordion from './modules/accordion'
import FormAdhesion from './modules/form-adhesion'
import FormDonation from './modules/form-donation'
import FormInscription from './modules/form-inscription'
import FormPaiement from './modules/form-paiement'
import FormMethode from './modules/form-methode'
import '@fancyapps/fancybox'
import './plugins/gallery'
import './plugins/timeline'
import './plugins/blog-carousel'
import './plugins/news-carousel'
import './plugins/personnel-row'
import './plugins/form-profile'
import './plugins/form-babillard'

$(function() {
  /* Globals */
  $.mlmi = {
    mobile: new Mobile(),
    header: undefined,
  }

  /* Prevent empty anchor clicks */
  $('a[href="#"]').on("click", function() {
    return false
  })

  /* Tabindex */
  $('.lost-password').attr('tabindex', '-1')

  /* Hover click toggle */
  $('.header-login--logged-in .header-login__link').on('click', function(e) {
    if ($('html').hasClass('has-touch')) {
      return false
    }
  })

  /* Header */
  $.mlmi.header = Header.init()

  /* Submenu */
  $('.main-menu > .main-menu__item--parent').each(function() {
    $(this).SubMenuParent({
      mobile: false,
    })
  })

  /* Accordions */
  Accordion.init()

  /* Newsletter */
  if ($('.newsletter-form').length) {
    new Form('.newsletter-form', {
      ajax_url: culturemontreal_l10n.ajax_url,
      auto_scroll: true,
      onSuccess: function() {
        $('.newsletter-form').find('.field--type-email').html('<p class="text-success mt-2">Inscription effectuée avec succès.</p>');
        $('.newsletter-form').find('.submit-container').hide();
      }
    })
  }

  /* Galleries */
  $('.gallery').each(function() {
    $(this).Gallery()
  })

  /* Timelines */
  $('.timeline').each(function() {
    $(this).Timeline()
  })

  /* Home carousel */
  $('.news-carousel').each(function() {
    $(this).NewsCarousel()
  })

  /* Articles carousel */
  $('.blog-carousel').each(function() {
    $(this).BlogCarousel()
  })

  /* Personnel row */
  $('.personnel-row').each(function() {
    $(this).PersonnelRow()
  })

  /* Formulaires */
  FormAdhesion.init()
  FormDonation.init()
  FormInscription.init()
  FormPaiement.init()
  FormMethode.init()

  /* Formulaire de profil */
  $('.profile-form').each(function() {
    $(this).FormProfile()
  })

  /* Formulaire de babillard */
  $('.babillard-form').each(function() {
    $(this).FormBabillard()
  })

  /* Hide activities section if none current */
  $('.activites-list').each(function() {
    if (!$(this).find('.activite').length) {
      $(this).hide()
    }
  })

  /* Popups */
  $('a[href="#desactiver-adhesion"]').fancybox({
    src: '#desactiver-adhesion',
    type: 'inline',
  })
  $('a[href="#desactiver-adhesion-confirmation"]').on('click', function() {
    $('input[name="disable_automatic_renewal"]').val('1')
    $('form.edit-adhesion-form').submit()
    return false
  })

  $('.card-promo__copy[data-code]').each(function () {
    const $btn = $(this);
    $btn.on('click', function () {
      const code = $btn.data('code');
      navigator.clipboard.writeText(code).then(() => {
        const originalText = $btn.text();
        $btn.text('Code copié !');
        setTimeout(() => {
          $btn.text(originalText);
          $btn.blur();
        }, 2000);
      });
    });
  });
})
